import { Skeleton } from "@/components/ui/skeleton";

export function PageHeader({ overline, title, children }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div>
        {overline && <div className="overline-label mb-2">{overline}</div>}
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight leading-none">{title}</h1>
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}

export function Metric({ label, value, hint, accent, testId }) {
  return (
    <div className="p-5 border-r border-b border-zinc-800 last:border-r-0 h-full" data-testid={testId}>
      <div className="overline-label">{label}</div>
      <div className={`font-display text-3xl font-bold tracking-tight mt-2 ${accent ? "text-orange-500" : ""}`}>{value}</div>
      {hint && <div className="text-xs text-zinc-500 mt-1">{hint}</div>}
    </div>
  );
}

export function MetricGrid({ children }) {
  return <div className="grid grid-cols-2 lg:grid-cols-4 border border-zinc-800 border-b-0 border-r-0 bg-zinc-900/60 rounded-sm overflow-hidden">{children}</div>;
}

export function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div className="panel p-12 text-center" data-testid={testId}>
      {Icon && <Icon className="h-10 w-10 mx-auto text-zinc-600" strokeWidth={1.5} />}
      <h3 className="font-display text-lg font-semibold mt-4">{title}</h3>
      {description && <p className="text-sm text-zinc-400 mt-1 max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function LoadingRows({ n = 4 }) {
  return (
    <div className="space-y-2" data-testid="loading-skeleton">
      {Array.from({ length: n }).map((_, i) => (
        <Skeleton key={i} className="h-12 bg-zinc-800 rounded-sm" />
      ))}
    </div>
  );
}

export function Code({ children, testId }) {
  return (
    <pre className="font-mono text-xs leading-relaxed bg-zinc-950 border border-zinc-800 rounded-sm p-4 overflow-x-auto" data-testid={testId}>
      {children}
    </pre>
  );
}
